import { render } from "./letter-pattern-attachment.vue?vue&type=template&id=752441bf"
import script from "./letter-pattern-attachment.vue?vue&type=script&lang=js"
export * from "./letter-pattern-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__